import ChevronDown from "@/assets/icons/chevron-down.svg";
import ChevronUp from "@/assets/icons/chevron-up.svg";
import { useEpisode } from "@/containers/Episode/context";
import { pluralize } from "@/utils";
import TextButton from "@components/TextButton";

import styles from "./ExpandMentions.module.css";

const ExpandMentions: React.FunctionComponent<{
  open: boolean;
}> = ({ open }) => {
  const { mentions } = useEpisode();
  return (
    <TextButton
      className={styles.root}
      iconPlacement="after"
      icon={open ? ChevronUp : ChevronDown}
    >
      {`${mentions.length} ${pluralize(
        mentions.length,
        L.MENTIONS_VIEW_INTRO_MENTIONS_SINGULAR,
        L.MENTIONS_VIEW_INTRO_MENTIONS_PLURAL
      )}`}
    </TextButton>
  );
};

export default ExpandMentions;
